import * as React from "react";
import * as DatePicker from "react-datepicker";
import * as moment from "moment";
import {AbstractInputElement, FormElement} from "./FormInput";

class CustomInput extends React.Component<CustomInputProps, {}> {
    render() {
        return (
            <div className={this.props.className} onClick={this.props.onClick}>{this.props.value}</div>
        );
    }
}

interface CustomInputProps {
  className?: string;
  onClick?: () => void;
  value?: any;
}

interface Props extends FormElement<string, HTMLInputElement> {
    timeZoneId?: string;
}

export class FormDatePicker extends AbstractInputElement<string | number, Props, {}> {

    getDefaultValue() {
        return null;
    }

    handleChange(date) {
        let value = this.extractDate(date);

        this.onChange(value);
    }

    extractDate(date) {
        if (date == null) {
            return null;
        }
        let value = (date as any).valueOf();

        if (this.props.timeZoneId) {
            let d = new Date();
            d.setTime(value);
            let date = {year: d.getFullYear(), month: d.getMonth(), day: d.getDate()}
            console.log("DATE = ", date);
            value = moment.tz(date, this.props.timeZoneId).valueOf();
        }
        return value;
    }

    render() {


        return <DatePicker className={this.getClassNames()}
                           customInput={<CustomInput className={this.getClassNames()}/>}
                           selected={this.getModelValue() != null ? moment.tz(this.getModelValue(), this.props.timeZoneId) : null}
                           onChange={this.handleChange.bind(this)}
                           isClearable/>
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/form/FormDatePicker.tsx